
import { Vue, Component, Prop } from "vue-property-decorator";
import { ImagePath } from "../views/ImagePath";

@Component({ components: {} })
export default class MessageInOut extends Vue {
  private inputMessage = "";
  private filterKeyword = "";

  @Prop({ default: "" })
  private porpInput!: string;

  @Prop({ default: [] })
  private images!: ImagePath[];

  get imagesModel() {
    return this.images.filter(
      (item) => this.filterKeyword == "" || item.class !== this.filterKeyword
    );
  }

  private hello() {
    alert("hello");
  }

  private filterB() {
    this.filterKeyword = "3dmodel";
  }

  private clearFilter() {
    this.filterKeyword = "";
  }

  private itemdelete(item: ImagePath) {
    console.log(item);
    // this.images.splice(
    //   this.images.findIndex((p) => p === item),
    //   1
    // );
    this.$emit("deleteItem", item.name);
  }
}
